import * as React from "react";
import {Fragment} from "react";
import Aside from "../Aside/Aside";
import CopyToClipboard from "../../CopyToClipboard";
import FetchData from "../../backend/FetchData";
import Spinner from "../Process/Spinner";
import Share from "./Share";

class Create extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			creating: false,
			created: false,
			id: {
				char1: false,
				char2: false,
				char3: false,
				char4: false,
				char5: false,
				char6: false
			}
		}
		this.handleClick = this.handleClick.bind(this);
	}

	handleClick() {
		this.setState({creating: true}, () => {

			let result = [];
			document.querySelectorAll('input, select').forEach(input => {
				if(input.value !== null && input.value !== '' && input.value !== false) {
					console.log(`set ${input.id} to ${input.value}`)
					result.push({id: input.id, value: input.value})
				}
			});

			FetchData('/api/configuration/create', 'POST', false, false, result).then(result => {

				const code = result.code.split('');

				this.setState({
					id: {
						char1: code[0],
						char2: code[1],
						char3: code[2],
						char4: code[3],
						char5: code[4],
						char6: code[5],
					}
				}, () => {
					this.setState({created: true});
					CopyToClipboard(result.code);
				});

			});

		});
	}

	render() {

		const {creating, created} = this.state;
		const {char1, char2, char3, char4, char5, char6} = this.state.id;

		return (
			<Fragment>
				<Aside title="Konfiguration speichern">
					<p>Um sich eine Markisenkonfiguration für später zu speichern, kopieren Sie sich einfach die Konfigurations-ID. Diese kann dann wieder importiert werden, um Ihre Konfiguration erneut abzurufen.</p>

					<div className="d-block">

						{creating && !created &&
							<div className="d-flex align-items-center text-center justify-content-center">
								<Fragment>
									<Spinner style="rotate"/>
									<span className="ms-3 text-primary">
									 Wird gespeichert ...
								</span>
								</Fragment>
							</div>
						}

						{created &&
							<Fragment>
								<div className="row align-items-center mt-3">
									<div className="col-2 text-center">
										<span className="h4 text-primary">{char1}</span>
									</div>
									<div className="col-2 text-center">
										<span className="h4 text-primary">{char2}</span>
									</div>
									<div className="col-2 text-center">
										<span className="h4 text-primary">{char3}</span>
									</div>
									<div className="col-2 text-center">
										<span className="h4 text-primary">{char4}</span>
									</div>
									<div className="col-2 text-center">
										<span className="h4 text-primary">{char5}</span>
									</div>
									<div className="col-2 text-center">
										<span className="h4 text-primary">{char6}</span>
									</div>
								</div>
								<small className="d-block text-center text-muted mt-2">
									Ihre Konfiguration wurde gespeichert und die Konfigurations-ID wurde in die Zwischenablage kopiert.
								</small>
								<div className="mt-4">
									<Share code={char1 + char2 + char3 + char4 + char5 + char6} />
								</div>
							</Fragment>
						}

						{!created && !creating &&
							<button type="button" className="btn btn-outline-primary btn-lg w-100 d-block" onClick={() => this.handleClick()} >
								Konfiguration speichern
							</button>
						}

					</div>
				</Aside>
			</Fragment>
		);
	}
}

export default Create;
